<template>
    <eod-dialog persistent :hide-cancel="showOptions" :loading="loading" v-if="project" width="800" :value="value" @input="val => $emit('input', val)" :title="'Toegang '+project.name" icon="mdi-folder-open-outline" iconColor="primary">
        <v-snackbar right top v-model="isMailSendErrorSnackbarVisible" timeout="5000" color="error" @click.native="isMailSendErrorSnackbarVisible = false"><v-icon left>mdi-alert-circle-outline</v-icon>Fout bij het versturen van de e-mail</v-snackbar>
        <v-snackbar right top v-model="isMailSendSnackbarVisible" timeout="5000" color="success" @click.native="isMailSendSnackbarVisible = false"><v-icon left>mdi-check-circle-outline</v-icon>E-mail succesvol verstuurd</v-snackbar>
        <eod-contacts :key="refreshContacts" @input="updateUsers" v-model="project.users" :roles="['contributor', 'responsible']" :import-show="false" :export-show="false">
            <template v-slot:actions="{user}">
                <v-tooltip top v-if="$eod.getUser().can('organization.contacts.update') && user.id !== $eod.getUser().id">
                    <template v-slot:activator="{on:menuOn, attrs:menuAttrs}">
                        <v-menu bottom left>
                            <template v-slot:activator="{on, attrs}">
                                <eod-btn v-on="{...menuOn, ...on}" v-bind="{...menuAttrs, ...attrs}" icon :color="userRoles[(new User(user)).getRole()?.name]?.color"><v-icon>{{ userRoles[(new User(user)).getRole()?.name]?.icon || 'mdi-account-eye' }}</v-icon></eod-btn>
                            </template>
                            <v-list dense>
                                <v-list-item v-for="(role, index) in userRoles" :key="index" @click="setUserRole(user, role.value)">
                                    <v-list-item-icon>
                                        <v-icon :color="role.color">{{ role.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ role.text }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    {{userRoles[(new User(user)).getRole()?.name]?.text}} (Deze instellingen zijn van toepassing op alle projecten en dashboards)
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{on, attrs}">
                        <eod-btn :loading="sendMailLoading[user.id]" @click="resendProjectMail(user)" v-on="on" v-bind="attrs" icon><v-icon small>mdi-send</v-icon></eod-btn>
                    </template>
                    Uitnodiging opnieuw versturen
                </v-tooltip>
            </template>
        </eod-contacts>
        <eod-card color="grey lighten-3" outlined class="mt-4" :title="'Toegang tot bedrijf '+project.company.name" v-if="project && project.company && project.company.users && project.company.users[0]">
                <eod-contacts flat :value="project.company.users" :roles="['contributor', 'responsible']" :import-show="false" :export-show="false" readonly></eod-contacts>
        </eod-card>
        <template v-slot:footer>
            <div class="w-100 px-4 grey darken-2 text--white py-2" v-if="showOptions && !loading">
                <v-checkbox dark class="my-0" v-model="options.mailProjectAccess" hide-details label="Nieuwe leden laten weten dat ze zijn toegevoegd aan het project"></v-checkbox>
                <eod-textarea rows="3" class="white my-2" v-if="options.mailProjectAccess" v-model="options.mailProjectAccessText" info="Bericht om mee te sturen met de e-mail." placeholder="Extra info (optioneel)"></eod-textarea>
                <v-checkbox dark class="my-0" v-model="options.addToCriticalAlarms" hide-details label="Nieuwe leden automatisch meldingen geven bij een kritiek alarm voor dit project"></v-checkbox>
            </div>
        </template>
        <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!showOptions" text rounded @click="$emit('input', false)">
                Sluiten
            </v-btn>
            <v-btn v-if="showOptions" :loading="loading" color="primary" rounded @click="saveUsers">
                <v-icon left>mdi-content-save</v-icon>Opslaan
            </v-btn>
        </template>
    </eod-dialog>
</template>
    <script>
    import eodDialog from './eod-dialog';
    import eodContacts from './eod-contacts.vue';
    import eodBtn from './eod-btn.vue';
    import Project from '../models/project';
    import User from '../models/user';
    
    export default{
        name: 'eod-project-access-dialog',
        components:{
            eodDialog,
            eodContacts,
            eodBtn
        },
        props:{
            value: Boolean,
            projectId: String
        },
        data(){
            return {
                userRoles: {
                    contributor: {
                        value: 'contributor',
                        text: 'Enkel weergeven',
                        icon: 'mdi-account-eye',
                        color:'warning'
                    },
                    responsible: {
                        value: 'responsible',
                        text: 'Weergeven en instellen',
                        icon: 'mdi-account-edit',
                        color:'success'
                    }
                },
                refreshContacts: 98343,
                loading: false,
                initialUsers:null,
                User:User,
                newUsers:[],
                project:null,
                showOptions:false,
                options: {
                    mailProjectAccess: true,
                    mailProjectAccessText: null,
                    addToCriticalAlarms: true,
                },
                isMailSendSnackbarVisible: false,
                isMailSendErrorSnackbarVisible: false,
                sendMailLoading: {}
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            setUserRole(user, role){
                this.$eod.update('UserRole', {
                    id: user.id,
                    roleName: role
                }).then(() => {
                    for (let i = 0; i < this.project.users.length; i++) {
                        const projectUser = this.project.users[i];
                        if(projectUser.id === user.id){
                            this.project.users[i].assignedRealmRoles = [{
                                name: role
                            }];
                            break;
                        }
                    }
                    this.refreshContacts++;
                });
            },
            async updateUsers(users){
                this.loading = true;
                this.showOptions = false;
                
                // Show options when new user is added
                for (let i = 0; i < users.length; i++) {
                    const user = users[i];
                    if(!this.initialUsers.includes(user.id)){
                        this.newUsers.push(user.id);
                        this.showOptions = true;
                        break;
                    }
                }

                this.initialUsers = users.map(item => item.id);

                // Save project
                const project = new Project(this.project);
                const data = await project.getSaveData();
                await this.$eod.save('Project', data);

                this.loading = false;
            },
            init(){
                // Get project users
                this.$eod.getById('project', this.projectId, ['id', 'name', 'users{id}', 'company{id name users{id}}']).then(response => {
                    if(response.data.data.project){
                        this.project = response.data.data.project;
                        this.initialUsers = this.project.users.map((item) => {return item.id});
                    }
                })
            },
            resendProjectMail(user){
                this.sendMailLoading[user.id] = true;
                this.$eod.sendMail([user.email], 'ProjectAccessMail', {
                    project_id: this.projectId,
                    user_id: user.id,
                    owner_id: this.$eod.getUser().id,
                    text: null
                }).then(response => {
                    this.isMailSendSnackbarVisible = true;
                }).catch(() => {
                    this.isMailSendErrorSnackbarVisible = true;
                }).finally(() => {
                    this.sendMailLoading[user.id] = false;
                    this.$forceUpdate();
                });
            },
            async saveUsers(){

                this.loading = true;
            
                // Check if added users need e-mail or alarm notifications 
                for (let i = 0; i < this.project.users.length; i++) {
                    const newUser = new User(this.project.users[i]);
                    if(this.newUsers.includes(newUser.id)){
                        if(this.options.mailProjectAccess){
                            await this.$eod.sendMail([newUser.email], 'ProjectAccessMail', {
                                project_id: this.projectId,
                                user_id: newUser.id,
                                owner_id: this.$eod.getUser().id,
                                text: this.options.mailProjectAccessText
                            });
                        }

                        if(this.options.addToCriticalAlarms){
                            if(!newUser.notificationSettings){
                                newUser.notificationSettings = {};
                            }

                            if(!newUser.notificationSettings.notifications){
                                newUser.notificationSettings.notifications = {};
                            }

                            newUser.notificationSettings.notifications.crit = ['email'];

                            if(!newUser.notificationSettings.alarms){
                                newUser.notificationSettings.alarms = [];
                            }

                            newUser.notificationSettings.alarms.push({
                                id: this.projectId,
                                class: 'PROJECT',
                                module: 'projects',
                            });

                            // Delete these relation so link would'n disappear
                            delete newUser.projects;
                            delete newUser.companies;

                            const data = await newUser.getSaveData();
                            await this.$eod.save('User', data);
                        }
                    }
                }

                this.loading = false;

                this.$emit('input', false);
            }
        }
    }
    </script>